import { RenderViewSdgAlignmentsParams } from '@upright/common/renderer/component-types/types-render-view-sdg-alignments';
import { RenderViewComponentType } from '@upright/common/renderer/types';
import { ChartTitle } from '@upright/ui/views/render-view/controls/chart-title';
import { ComponenControlWrap } from '@upright/ui/views/render-view/controls/shared';
import { useGetRenderViewComponentParamSetter } from '../../../context/component-param-setter';
import { BooleanRadioButtonControl } from '../../../controls/boolean-radio-button-control';
import { getRenderViewSdgDefaultTitle } from '../get-render-view-sdg-default-title';

export const RenderViewSdgAlignmentsControls = (props: { params: RenderViewSdgAlignmentsParams }) => {
  const { params } = props;

  const setParams = useGetRenderViewComponentParamSetter(RenderViewComponentType.SDG_ALIGNMENTS);

  return (
    <ComponenControlWrap>
      <ChartTitle {...{ params }} defaultTitle={getRenderViewSdgDefaultTitle(params)} />
      <BooleanRadioButtonControl
        {...{
          texts: {
            title: 'SDGs without alignment',
            true: 'Show',
            false: 'Hide',
          },
          currentValue: params.sdgIdsToShow === 'nonEmpty' ? false : true,
          onChange: newValue => {
            const paramValue = ((): RenderViewSdgAlignmentsParams['sdgIdsToShow'] => {
              if (!newValue) return 'nonEmpty';
              return undefined;
            })();
            setParams(curr => ({ ...curr, sdgIdsToShow: paramValue }));
          },
        }}
      />
      <BooleanRadioButtonControl
        {...{
          texts: {
            title: 'Layout',
            true: 'Normal',
            false: 'Tight',
          },
          currentValue: params.layout === 'tight' ? false : true,
          onChange: newValue => {
            const paramValue = ((): RenderViewSdgAlignmentsParams['layout'] => {
              if (!newValue) return 'tight';
              return undefined;
            })();
            setParams(curr => ({ ...curr, layout: paramValue }));
          },
        }}
      />
    </ComponenControlWrap>
  );
};
